import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningProfileLookup extends Layout {
    sourceOrderPlanningProfile: DataSource;
    tableLookup: Table;
}
